import { ROUTE_HEALTH_DATA } from '@/constants/routes';
import { motion } from 'motion/react';
import { useNavigate } from 'react-router-dom';

interface HealthDataHeaderTitleProps {
  className?: string;
}

export function HealthDataHeaderTitle({
  className = '',
}: HealthDataHeaderTitleProps) {
  const navigate = useNavigate();

  return (
    <motion.div
      className={`flex flex-col items-start text-left w-full h-full hidden md:flex ${className}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="flex-1 flex flex-col justify-between w-full h-full py-4">
        <motion.div
          className="text-white/70 text-sm font-medium uppercase tracking-wide"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Health Overview
        </motion.div>

        <motion.h1
          className="text-white text-4xl md:text-5xl font-normal leading-tight text-left"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
         Your Health Data
        </motion.h1>

        {/* Divider */}
        <motion.div
          className="w-full h-px bg-white/20"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        />

        <motion.div
          className="text-white/80 text-base md:text-lg leading-relaxed text-left"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          Your Health Data is where your lifestyle, history, and test results come together to power your personalized risk model.
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          <span
            className="font-semibold leading-[1.3] text-[#7cf1c7] text-[16px] underline cursor-pointer hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-[#7cf1c7] focus:ring-opacity-50 rounded-sm"
            aria-label="Update your health data"
            onClick={() => navigate(ROUTE_HEALTH_DATA)}
          >
            Update your health data
          </span>
        </motion.div>
      </div>
    </motion.div>
  );
}
